import { useTranslation } from "react-i18next";

import { Container, Title } from "./styles";

function PlaceholderText({ label = "" }) {
  const { t } = useTranslation();

  return (
    <Container>
      <Title>{!label ? t("BTN_NO_CLASSES_FOUND") : t(label)}</Title>
    </Container>
  );
}

export default PlaceholderText;
